import { Cart as CartComponent } from 'components/orders/cart'
import PageTransition from 'components/PageTransition'
import TopNav from 'components/TopNav'
import { Outlet, useMatch, useNavigate } from 'react-router-dom'

export default function Cart() {
  const navigate = useNavigate()
  const isPage = !!useMatch('/providers/pharmacies/cart/')
  const isFromEazyMedPage = !!useMatch('/easy-med/cart/')

  return (
    <>
      <TopNav title="My Cart" />
      <PageTransition show={isPage || isFromEazyMedPage}>
        <CartComponent next={(id) => navigate(`${id}`)} />
      </PageTransition>

      <PageTransition show={!isPage}>
        <Outlet />
      </PageTransition>
    </>
  )
}
